const stateKeys = {
  format: 'format',
  interval: 'interval',
  hasSolar: 'hasSolar',
  hasHeatpump: 'hasHeatpump',
  shSupported: 'shSupported',
  dhwSupported: 'dhwSupported',
  showBudgetRelatedData: 'showBudgetRelatedData'
}

export const state = () => ({
  hasSolar: false,
  hasHeatpump: false,
  shSupported: false,
  dhwSupported: false,
  showBudgetRelatedData: false
})

export const mutations = {
  updateHasSolar(state, value) {
    state.hasSolar = value
  },
  updateHasHeatpump(state, value) {
    state.hasHeatpump = value
  },
  updateShowBudgetRelatedData(state, value) {
    state.showBudgetRelatedData = value
  },
  updateShSupported(state, value) {
    state.shSupported = value
  },
  updateDhwSupported(state, value) {
    state.dhwSupported = value
  }
}

export const actions = {
  clearStorage() {
    for (const prop in stateKeys) {
      this.$storage.removeUniversal(stateKeys[prop])
    }
  },

  getConsumptionFormat() {
    return (
      this.$storage.getUniversal(stateKeys.format) ||
      this.$getConsumptionFormat('grid')
    )
  },

  setConsumptionFormatByValue(_, value) {
    const format = value
      ? this.$getConsumptionFormat('currency')
      : this.$getConsumptionFormat('grid')

    this.$storage.setUniversal(stateKeys.format, format)
  },

  setConsumptionFormat(_, value) {
    this.$storage.setUniversal(stateKeys.format, value)
  },

  getInterval() {
    return (
      this.$storage.getUniversal(stateKeys.interval) ||
      this.$tabItems('period')[0]
    )
  },

  setInterval(_, value) {
    this.$storage.setUniversal(stateKeys.interval, value)
  },

  getHasSolar() {
    return this.$storage.getUniversal(stateKeys.hasSolar)
  },

  setHasSolar({ commit }, value) {
    commit('updateHasSolar', value)
    this.$storage.setUniversal(stateKeys.hasSolar, value)
  },

  getHasHeatpump() {
    return this.$storage.getUniversal(stateKeys.hasHeatpump)
  },

  setHasHeatpump({ commit }, value) {
    commit('updateHasHeatpump', value)
    this.$storage.setUniversal(stateKeys.hasHeatpump, value)
  },

  getShowBudgetRelatedData() {
    this.$storage.getUniversal(stateKeys.showBudgetRelatedData)
  },

  setShowBudgetRelatedData({ commit }, value) {
    commit('updateShowBudgetRelatedData', value)
    this.$storage.setUniversal(stateKeys.showBudgetRelatedData, value)
  },

  getShSupported() {
    return this.$storage.getUniversal(stateKeys.shSupported)
  },

  setShSupported({ commit }, value) {
    commit('updateShSupported', value)
    this.$storage.setUniversal(stateKeys.shSupported, value)
  },

  getDhwSupported() {
    return this.$storage.getUniversal(stateKeys.dhwSupported)
  },

  setDhwSupported({ commit }, value) {
    commit('updateDhwSupported', value)
    this.$storage.setUniversal(stateKeys.dhwSupported, value)
  },

  async logout({ dispatch }) {
    await dispatch('energy/appliance/clearStorage', {}, { root: true })
    await dispatch('energy/forecast/clearStorage', {}, { root: true })
    await dispatch('energy/history/clearStorage', {}, { root: true })
    await dispatch(
      'energy/settings/pvoptimisation/clearStorage',
      {},
      { root: true }
    )
    await dispatch(
      'energy/settings/energysaving/clearStorage',
      {},
      { root: true }
    )
  }
}
